import StepLoginDialog from "@/components/StepLoginDialog";

export default function LoginPage() {
  return <StepLoginDialog mode="page"/>;
}
